import React from 'react';
import { Text } from '@sitecore-jss/sitecore-jss-react';

import { isJssField, JssTextType } from 'core/utils/sitecore-utils';

import * as S from './HelpText.style';

interface IProps {
	id?: string;
	children: React.ReactNode | string;
}

const HelpText = ({ children: helpText, id, ...props }: IProps) => (
	<S.HelpText {...{ id, ...props }}>
		{isJssField(helpText) ? <Text field={helpText as JssTextType} /> : helpText}
	</S.HelpText>
);

export default HelpText;
